export const language = [
  { lng: 'pt-BR', label: 'Português (BRL)', icon: '🇧🇷' },
  { lng: 'en-US', label: 'Inglês (EUA)', icon: '🇺🇸' },
];
